import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { BsArrowRight, BsStarFill } from 'react-icons/bs';
import { FaChalkboardTeacher, FaClock, FaCertificate } from 'react-icons/fa';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import axios from 'axios';
import { config } from '../config';

import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import * as AiIcons from 'react-icons/ai';
import * as BsIcons from 'react-icons/bs';

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleEnrollClick = (course) => {
    setSelectedCourse(course);
    setShowMessage(true);
  };

  useEffect(() => {
    axios.get(`${apiUrl}/courses`)
      .then((response) => {
        // Sort courses by sort_order if available
        const sortedCourses = response.data.courses.sort((a, b) => {
          return (a.sort_order || 0) - (b.sort_order || 0);
        });
        setCourses(sortedCourses);
        setLoading(false);
      })
      .catch((error) => {
        setError('Failed to load courses. Please try again later.');
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/memberships`);
        setMemberships(response.data || []);

        console.log(response.data)
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load memberships. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  console.log(memberships)

   const getIconComponent = (iconName) => {
          const libraries = { ...FaIcons, ...MdIcons, ...AiIcons, ...BsIcons };
          const Icon = libraries[iconName];
          return Icon ? <Icon /> : <span>✅</span>;
        };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-6 bg-white rounded-lg shadow-md max-w-md">
          <h3 className="text-xl font-bold text-gray-800 mb-4">Error Loading Courses</h3>
          <p className="text-gray-600 mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      
      <main className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
        {/* Hero Section */}
        <section className="relative py-20 bg-gradient-to-r from-green-600 to-blue-600 text-white overflow-hidden pt-32">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-purple-300 rounded-full mix-blend-screen filter blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-300 rounded-full mix-blend-screen filter blur-3xl"></div>
          </div>
          
          <div className="container mx-auto px-4 relative z-10 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-3xl mx-auto"
            >
              <h1 className="text-4xl md:text-5xl font-bold mb-6">আমার কোর্সসমূহ</h1>
              <p className="text-xl md:text-2xl mb-8">
                পেশাদার মানের প্রশিক্ষণ যা আপনার ক্যারিয়ারকে দেবে নতুন মাত্রা
              </p>
            </motion.div>
          </div>
        </section>

        {/* Courses Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            {/* Courses Grid */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            >
              {courses.map((course, index) => (
                <motion.div
                  key={course.id || index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ y: -10 }}
                  className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 group"
                >
                  {/* Course Image */}
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={`${imageUrl}/${course.image}`}
                      alt={course.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    {course.offer_price && (
                      <div className="absolute top-4 right-4 bg-yellow-400 text-black font-bold px-3 py-1 rounded-full text-xs shadow-md">
                        Special Offer
                      </div>
                    )}

                    {/* Membership Type Badge - নতুন কোড যোগ করুন */}
                    {course.membership_type && (
                      <div className={`absolute top-4 left-4 text-white font-bold px-3 py-1 rounded-full text-xs shadow-md ${
                        course.membership_type === '1' ? 'bg-purple-500' : 
                        course.membership_type === '2' ? 'bg-yellow-500' : 
                        course.membership_type === '3' ? 'bg-red-500' : 
                        'bg-gray-500'
                      }`}>
                        {memberships.find(m => m.id === Number(course.membership_type))?.membership_type || 'Premium'}
                      </div>
                    )}
                  </div>

                  {/* Course Content */}
                  <div className="p-6">
                    {/* <div className="flex items-center mb-3">
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <BsStarFill 
                            key={i} 
                            className={`text-sm ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`} 
                          />
                        ))}
                      </div>
                      <span className="text-sm text-gray-500 ml-2">(42 reviews)</span>
                    </div> */}

                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-green-600 transition-colors">
                      {course.name}
                    </h3>

                    <p className="text-gray-600 mb-6 line-clamp-2">
                      {course.desc}
                    </p>

                    {/* <div className="flex items-center justify-between mb-6">
                      <div className="flex items-center space-x-4">
                        <div className="flex items-center text-gray-500 text-sm">
                          <FaChalkboardTeacher className="mr-2" />
                          <span>Expert</span>
                        </div>
                        <div className="flex items-center text-gray-500 text-sm">
                          <FaClock className="mr-2" />
                          <span>{course.duration || '8 Weeks'}</span>
                        </div>
                      </div>
                      <div className="flex items-center text-gray-500 text-sm">
                        <FaCertificate className="mr-2 text-green-500" />
                        <span>Certificate</span>
                      </div>
                    </div> */}

                    <div className="flex items-center justify-between mb-6">
                      <div>
                        {course.offer_price ? (
                          <>
                            <span className="text-gray-400 line-through mr-2">
                              ৳{course.price}
                            </span>
                            <span className="text-2xl font-bold text-green-600">
                              ৳{course.offer_price}
                            </span>
                          </>
                        ) : (
                          <span className="text-2xl font-bold text-green-600">
                            ৳{course.price}
                          </span>
                        )}
                      </div>
                    </div>

                    <button
                      onClick={() => handleEnrollClick(course)}
                      className="w-full py-3 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-lg hover:from-green-600 hover:to-green-700 transition-all shadow-md hover:shadow-lg"
                    >
                      Enroll Now
                    </button>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        {/* Membership Modal */}
        {showMessage && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <motion.div 
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            >
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-2xl font-bold text-gray-800">
                    {selectedCourse?.name}
                  </h3>
                  <button 
                    onClick={() => setShowMessage(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    ✕
                  </button>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                  <h4 className="font-bold text-yellow-800 mb-2">প্রিয় শিক্ষার্থী,</h4>
                  <p className="text-yellow-700 mb-3">
                    এই কোর্সটি সরাসরি ক্রয় করা সম্ভব নয়, কারণ আমরা আমাদের শিক্ষার্থীদের জন্য উন্নত মানের প্রিমিয়াম শিক্ষণ পদ্ধতি ও নিরবিচ্ছিন্ন সাপোর্ট সিস্টেম প্রদান করি। এজন্য, আপনাকে আমাদের বিশেষ মেম্বারশিপ নিতে হবে।
                  </p>
                  <p className="text-yellow-700 font-semibold mb-2">
                    মেম্বারশিপের সুবিধাসমূহ:
                  </p>
                  <ul className="list-disc pl-5 text-yellow-700 space-y-1">
                    <li>বিশেষ এক্সক্লুসিভ কোর্স অ্যাক্সেস – যা সাধারণ শিক্ষার্থীরা পান না</li>
                    <li>সরাসরি এক্সপার্টদের গাইডলাইন ও সার্টিফিকেশন</li>
                    <li>নিয়মিত আপডেট ও নতুন কোর্সের অ্যাক্সেস</li>
                    <li>কমিউনিটি সাপোর্ট ও নেটওয়ার্কিং সুবিধা</li>
                    <li>ক্যারিয়ার গাইডেন্স ও জব প্লেসমেন্ট সহায়তা</li>
                  </ul>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  {memberships.map(membership => (
                        <div key={membership.id} className="border border-gray-200 rounded-lg p-4 hover:border-green-400 transition">
                          <h4 className="font-bold text-lg mb-2">{membership.membership_type}</h4>
                          <p className="text-3xl font-bold text-green-600 mb-2">৳{membership.discount_price}<span className="text-sm text-gray-500">/lifetime</span></p>
                           {/* Dynamic Benefits */}
                            {membership.benefits && membership.benefits.length > 0 && (
                              <div className="mt-6 mb-4">
                                {membership.benefits.map((benefit, i) => (
                                  <div key={i} className="flex items-center mb-2">
                                    <span className="mr-2">{getIconComponent(benefit.icon)}</span>
                                    <span className="text-gray-700">{benefit.benefit_name}</span>
                                  </div>
                                ))}
                              </div>
                            )}
                        </div>
                  ))
                  
                  }
                 
                </div>

                <div className="flex justify-end space-x-4">
                  <button 
                    onClick={() => setShowMessage(false)}
                    className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition"
                  >
                    Cancel
                  </button>
                  <Link 
                    to="/memberships" 
                    className="px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition font-medium"
                  >
                    View Membership Plans
                  </Link>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </main>

      <Footer />
    </>
  );
};

export default Courses;